
import { useState, useEffect } from 'react';

interface User {
  id: string;
  email: string;
  name: string;
}

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  // Hardcoded credentials
  const VALID_USERNAME = 'mamzz_73';
  const VALID_PASSWORD = 'TestMamzz94';

  useEffect(() => {
    // Check for stored user session
    const storedUser = localStorage.getItem('cryptotrade_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    setIsLoading(false);
  }, []);

  const login = async (username: string, password: string) => {
    setIsLoading(true);
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Check credentials
      if (username !== VALID_USERNAME || password !== VALID_PASSWORD) {
        return { success: false, error: 'Invalid username or password' };
      }
      
      const mockUser = {
        id: '1',
        email: 'mamzz_73@cryptotrade.com',
        name: 'Mamzz'
      };
      
      setUser(mockUser);
      localStorage.setItem('cryptotrade_user', JSON.stringify(mockUser));
      return { success: true };
    } catch (error) {
      return { success: false, error: 'Login failed' };
    } finally {
      setIsLoading(false);
    }
  };

  const register = async (email: string, password: string, name: string) => {
    setIsLoading(true);
    try {
      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Registration is disabled - only the specific user can access
      return { success: false, error: 'Registration is currently disabled. Please contact support.' };
    } catch (error) {
      return { success: false, error: 'Registration failed' };
    } finally {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('cryptotrade_user');
  };

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    login,
    register,
    logout
  };
}